import React, { useState, useEffect, useCallback } from "react";
import {
  Page,
  Card,
  PageActions,
  TextField,
  FormLayout,
  Toast,
  Loading,
  Checkbox,
  Box,
  Thumbnail,
  DropZone,
  InlineError,
  Text,
  Button,
  Modal,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams, useNavigate } from "react-router-dom";

const AddEditCategory = ({ mode }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [isSaving, setIsSaving] = useState(mode === "edit");

  const [item, setItem] = useState({
    name: "",
    is_active: true,
    // image: "",
  });

  const [errors, setErrors] = useState({
    name: "",
  });

  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileError, setFileError] = useState("");

  const handleDrop = useCallback((_dropFiles, acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length) {
      setFileError("Unsupported file type or size too large");
      return;
    }

    setFileError("");

    const file = acceptedFiles?.[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    setUploadedFile({
      file,
      url: previewUrl,
      name: file.name,
    });

    setItem((prev) => ({
      ...prev,
      image: previewUrl, // preview only
    }));
  }, []);

  const uploadedFilePreview = uploadedFile ? (
    <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <div>{uploadedFile.name}</div>
    </Box>
  ) : null;

  const handleChange = useCallback((field, value) => {
    setItem((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));

    if (field === "name") {
      setErrors((prev) => ({ ...prev, name: "" }));
    }
  }, []);

  const [active, setActive] = useState(false);
  const toggleActive = () => setActive((a) => !a);

  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const validateFields = () => {
    let hasError = false;
    const newErrors = { name: "" };

    if (!item.name?.trim()) {
      hasError = true;
      newErrors.name = "This field is required";
    }

    // if (!item.image) {
    //   hasError = true;
    //   setFileError("Image is required");
    // } else {
    //   setFileError("");
    // }

    setErrors((prev) => ({ ...prev, ...newErrors }));
    return !hasError;
  };

  useEffect(() => {
    if (mode === "edit") {
      axios
        .get(`/categories/${id}`)
        .then((result) => {
          console.log(result.data);
          setItem({
            name: result?.data?.name?.en || "",
            is_active: result?.data?.is_active ? true : false,
            // image: result?.data?.data?.image_url || "",
          });
          setIsSaving(false);
        })
        .catch(console.error);
    }
  }, [mode, id]);
  const [activeDelete, setActiveDelete] = useState(false);

  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/categories/${id}`)
      .then((result) => {
        navigate("/admin/categories");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${mode === "new" ? "Add" : "Edit"} Category`}
      backAction={{
        onAction: () => navigate("/admin/categories"),
      }}
      narrowWidth
    >
      {isSaving && <Loading />}
      <Card sectioned>
        <FormLayout>
          <TextField
            label="Name"
            value={item.name}
            onChange={(value) => handleChange("name", value)}
            error={errors.name}
          />

          {/* <Text>Sound</Text>
          <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
            <div>
              <Thumbnail
                size="large"
                source={
                  uploadedFile ? uploadedFile.url : item.image ? item.image : ""
                }
              />
            </div>

            <div style={{ width: "100%", marginLeft: "10px" }}>
              <DropZone
                accept=".mp3"
                type="image"
                onDrop={handleDrop}
                allowMultiple={false}
              >
                {uploadedFilePreview || (
                  <DropZone.FileUpload actionHint="Accepts MP3" />
                )}
              </DropZone>
            </div>
          </div>

          {fileError && <InlineError message={fileError} />} */}

          <Checkbox
            label="Is active"
            checked={item.is_active}
            onChange={(value) => handleChange("is_active", value)}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onAction: handleSave,
          loading: isSaving,
        }}
        secondaryActions={
          mode === "edit" && (
            <Button
              variant="primary"
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              Delete
            </Button>
          )
        }
      />
      {toastMarkup}{" "}
      <Modal
        open={activeDelete}
        onClose={() => setActiveDelete(false)}
        title="Delete Item"
        // primaryAction={{
        //   content: "Confirm Delete",
        //   destructive: true,
        //   onAction: handleYesDelete,
        //   loading: isSaving,
        // }}
        // secondaryActions={[
        //   { content: "Cancel", onAction: () => setActiveDelete(false) },
        // ]}

        primaryAction={{
          content: "Yes",
          destructive: true,
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: () => setActiveDelete(false),
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
    </Page>
  );

  function handleSave() {
    if (!validateFields()) return;

    setIsSaving(true);

    const formData = new FormData();
    if (mode === "edit") formData.append("_method", "PATCH");

    formData.append("name[en]", item.name);
    formData.append("is_active", item.is_active ? 1 : 0);

    if (uploadedFile?.file) {
      formData.append("image", uploadedFile.file);
    }

    axios
      .post(mode === "new" ? `/categories` : `/categories/${id}`, formData)
      .then(() => {
        mode === "new" ? navigate(`/admin/categories`) : toggleActive();
      })
      .catch(console.error)
      .finally(() => setIsSaving(false));
  }
};

export default AddEditCategory;
